import { ShopStatus } from '@/components/shared/Tags';

export type HealthStatusKey = 'Unhealthy' | 'Check' | 'Healthy' | 'Unknown';

export const HEALTH_ORDER: Record<HealthStatusKey, number> = {
    Unhealthy: 0,
    Check: 1,
    Unknown: 2,
    Healthy: 3
};

export enum HEALTH_STAUS {
    Unhealthy = 'Unhealthy',
    Check = 'Check',
    Unknown = 'Unknown',
    Healthy = 'Healthy',
}

export const toHealthKey = (raw: string): HealthStatusKey => {
    const normalized = raw?.toLowerCase() ?? '';
    if (normalized === 'unhealthy' || normalized === 'bad') return 'Unhealthy';
    if (normalized === 'check' || normalized === 'warning') return 'Check';
    if (normalized === 'healthy' || normalized === 'good') return 'Healthy';
    return 'Unknown';
};

export const resolveOperationModeTag = (mode: string) => {
    switch (mode?.toUpperCase().replace(/\s+/g, '_')) {
        case 'UNMANNED':
            return ShopStatus.Unmanned;
        case 'OUT_OF_SERVICE':
            return ShopStatus.Out_Of_Service;
        case 'CLOSED':
            return ShopStatus.Closed;
        case 'STAFFED':
            return ShopStatus.Staffed;
        case 'HYBRID':
            return ShopStatus.Hybrid;
        default:
            return null;
    }
};
